import { Tooltip } from '../tooltip/tooltip';
import { HelpList } from './help-list/help-list';

export const Help = ({ items }) => {
  return <Tooltip info={<HelpList items={items} />} />;
};
